var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preloader"},[(_vm.text)?_c('div',{staticClass:"preloader-text text-center"},[_vm._v(_vm._s(_vm.text))]):_vm._e(),_c('v-progress-linear',{attrs:{"indeterminate":"","color":_vm.iconcolor}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }